export const testimonials = [
  {
    id: 1,
    name: 'Marcus Chen',
    username: '@marcusfinds',
    avatar: 'MC',
    content: 'The Hipobuy Spreadsheet completely changed how I discover new sneakers. The organized categories make it so easy to find exactly what I am looking for without endless scrolling through different sites.',
  },
  {
    id: 2,
    name: 'Sophia Williams',
    username: '@sophiashops',
    avatar: 'SW',
    content: 'I was skeptical at first but this spreadsheet resource is genuinely impressive. The fashion category organization is next level. Saved me hours of research every week.',
  },
  {
    id: 3,
    name: 'James Rodriguez',
    username: '@jamesstreet',
    avatar: 'JR',
    content: 'As someone who runs a streetwear blog, the Hipobuy Spreadsheet is my go-to resource. The product database is comprehensive and the comparison tools help me make informed decisions fast.',
  },
  {
    id: 4,
    name: 'Emily Park',
    username: '@emilydiscovers',
    avatar: 'EP',
    content: 'The best shopping spreadsheet I have found online. The safety guides and verification tips helped me avoid sketchy sellers. This is a must-bookmark resource for anyone who shops online.',
  },
  {
    id: 5,
    name: 'David Thompson',
    username: '@davidthreads',
    avatar: 'DT',
    content: 'I have tried kakobuy spreadsheet and superbuy spreadsheet before, but the hipobuy version is way more organized. The category breakdown and filter options are unmatched in the spreadsheet shopping space.',
  },
  {
    id: 6,
    name: 'Olivia Martinez',
    username: '@oliviahaul',
    avatar: 'OM',
    content: 'Finally a resource that understands what online shoppers actually need. The Hipobuy Spreadsheet is not just a list - it is a properly organized product discovery system that makes finding items genuinely enjoyable.',
  },
];